import { render, staticRenderFns } from "./ZoomSetup.vue?vue&type=template&id=45f0f4fa&"
import script from "./ZoomSetup.vue?vue&type=script&lang=js&"
export * from "./ZoomSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports